module.exports = __webpack_public_path__ + "static/media/Bulk Job Upload Template.b0dbd027.xlsx";